import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/biweekly-mortgage-calculator',
  component: () => import('../../routes/BiweeklyMortgage.svelte'),
  card: {
    id: 'biweekly-mortgage',
    title: 'Biweekly Mortgage Calculator',
    description: 'Compare biweekly vs monthly mortgage payments and see how 26 payments per year can save you thousands in interest.',
    icon: 'calendar_month',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/biweekly-mortgage-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Biweekly Mortgage Calculator – Compare Monthly vs Biweekly Payments',
    description: 'Free biweekly mortgage calculator compares 26 biweekly payments vs 12 monthly payments. See how much interest you save and how many years you shave off your mortgage.',
  },
};

export default meta;